import $ from "jquery";
import * as bootbox from "bootbox";
import Seed from "DMS/Seed/All";
import * as checkFeatures from "DMS/Utils/checkFeatures";
export function getAndDisplayCgu(withCguValidationForm = false, racineFile = "") {
    let dialogConfig = {
        title: "<h4>" + LBL_CONFIDENTIALITE + "</h4>",
        message: LBL_CHARGEMENT,
        size: "large"
    };
    if (withCguValidationForm) {
        dialogConfig.buttons = {
            continuer: {
                label: "Continuer",
                className: "btn-primary confirmBtn pull-right",
                callback: () => {
                    location.href = "source/eservices.php?cgu=1";
                }
            },
            cancel: {
                label: "Annuler",
                className: "btn-default pull-right",
            }
        };
    }
    let dialogCgu = bootbox.dialog(dialogConfig);
    dialogCgu.on("shown.bs.modal", () => {
        dialogCgu.find(".modal-body").scrollTop(0);
    });
    if (withCguValidationForm) {
        dialogCgu.on("hidden.bs.modal", () => {
            $('#pass').val('');
            if ($('#renewPassword').length != 0) {
                $("#newpassword").val('');
                $("#passwordconfirm").val('');
                $("#renewPassword").hide();
            }
            $("#alert").removeClass("alert-danger alert-success").hide();
        });
    }
    dialogCgu.init(() => {
        dialogCgu.find(".confirmBtn").prop("disabled", true);
        dialogCgu.find(".modal-body").css("overflow-y", "auto");
        dialogCgu.find(".modal-body").css("max-height", "calc(100vh - 250px)");
        Seed.Ajax.Get({
            url: racineFile + "cgu.txt"
        }).then((text) => {
            dialogCgu.find(".bootbox-body").html((withCguValidationForm ? "<h4>" + MSG_LIRE_CGU + "</h4><br>" : "") +
                text.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br>$2") + // nl2br
                (withCguValidationForm ? "<h4>" + MSG_ACCEPTER_CGU.replace(":nomclient", $("#nomClient").text()) + "</h4><br>" : ""));
            if (!dialogCgu.has("#cguConfirmCheck").length > 0) {
                let checkCgu = $("<input>").attr("id", "cguConfirmCheck").attr("type", "checkbox").click(() => {
                    dialogCgu.find(".confirmBtn").prop("disabled", !dialogCgu.find("#cguConfirmCheck").is(":checked"));
                });
                let labelCgu = $("<label></label>").attr("for", "cguConfirmCheck").append($("<b>").text(LBL_CGU_ACCEPTER));
                let divCheckbox = $("<div>").addClass("checkbox pull-left").css("margin-left", "1vw").append(checkCgu, labelCgu);
                dialogCgu.find(".modal-footer").prepend(divCheckbox);
            }
        });
    });
}
// validation mot de passe : au moins 8 caracteres
// dont 1 minuscule, 1 majuscule, 1 chiffre
function passwordConfirmWithConstraint(password, passwordConfirm) {
    var passwordRegexp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
    var testValidPassword = false;
    if (password === passwordConfirm) {
        testValidPassword = passwordRegexp.test(password);
        if (!testValidPassword) {
            $("#alert").html(MSG_PASSWORD_NOT_SECURE).show();
        }
    }
    else {
        $("#alert").html(MSG_PASSWORD_NOT_CONFIRMED).show();
    }
    return testValidPassword;
}
export function initializeLoginCtrl() {
    // Bug 64861: TTP 13 : Tablette : modification dates non fonctionnel
    /* force les valeurs "supportDatetime" et "supportDate"
    *  => utilise le calendrier DMS (datepicker bootstrap)
    * car la date n'est pas enregistrée si on utilise le
    * calendrier natif tablette ou smartphone */
    /*
    var dateSupport = checkFeatures.checkInput('date') && checkFeatures.isPhoneOrTablet();
    var datetimeSupport = checkFeatures.checkInput('datetime-local') && checkFeatures.isPhoneOrTablet();
    */
    var dateSupport = false;
    var datetimeSupport = false;
    var numberSupport = checkFeatures.checkInput('number') && checkFeatures.isPhoneOrTablet();
    var timeSupport = checkFeatures.checkInput('time') && checkFeatures.isPhoneOrTablet();
    var smallDevice = checkFeatures.isSmallDevice();
    var isIos = checkFeatures.isIos();
    var deviceType = 'desktop';
    if (device.mobile() || smallDevice) {
        deviceType = "mobile";
    }
    else if (device.tablet()) {
        deviceType = "tablet";
    }
    // Focus sur login
    var logininput = document.getElementById('login');
    if (logininput) {
        logininput.focus();
    }
    $("#connexionForm").submit(function () {
        function loginFormSubmitted(token) {
            var renewPasswordDataSerialized = '';
            var testValidNewPassword = true;
            var $renewPassword = $('#renewPassword');
            var $newPassword = {};
            var $passwordConfirm = {};
            var newPassword = '';
            var passwordConfirm = '';
            let objToSend = {
                login: $("#login").val(),
                pass: $("#pass").val(),
                moduleType: moduleType,
                supportDate: dateSupport,
                supportNumber: numberSupport,
                supportTime: timeSupport,
                supportDatetime: datetimeSupport,
                isSmallDevice: smallDevice,
                isIos: isIos,
                deviceType: deviceType,
                language: $("#connectionButton").attr('data-language'),
                token_captcha: token
            };
            // on est sur le formulaire de renouvellement du mot de passe
            if ($renewPassword.length != 0
                && $renewPassword.css('display') != 'none') {
                $newPassword = $("#newpassword");
                $passwordConfirm = $("#passwordconfirm");
                newPassword = $newPassword.val();
                passwordConfirm = $passwordConfirm.val();
                testValidNewPassword = passwordConfirmWithConstraint(newPassword, passwordConfirm);
                if (!testValidNewPassword) {
                    $newPassword.val('');
                    $passwordConfirm.val('');
                }
                objToSend.newpassword = newPassword;
                objToSend.passwordconfirm = passwordConfirm;
            }
            if (testValidNewPassword) {
                // a la soumission du formulaire
                Seed.Ajax.Post({
                    url: root + "php_common/Login.php",
                    data: Seed.Ajax.formData(objToSend),
                    success: (msg) => {
                        if (msg === "success" || msg === 'cgu') {
                            $("#alert").html(MSG_SUCCESS)
                                .removeClass('alert-danger alert-success')
                                .addClass('alert-success')
                                .show();
                            if (msg == 'cgu') {
                                // affichage des CGU avec formulaire de validation
                                getAndDisplayCgu(true);
                            }
                            else {
                                if (moduleType === "ServiceMaint") {
                                    location.assign('source/eservices.php');
                                }
                                else {
                                    location.assign('source/index.php');
                                }
                            }
                        }
                        else {
                            $("#alert").removeClass("alert-danger alert-success")
                                .addClass('alert-danger')
                                .show();
                            $('#pass').val('');
                            if ($('#renewPassword').length != 0) {
                                $("#newpassword").val('');
                                $("#passwordconfirm").val('');
                            }
                            if (msg == 'renewPassword') {
                                $("#alert").html(MSG_RENEW_PASSWORD);
                                $("#renewPassword").show();
                            }
                            else {
                                $("#alert").html(msg);
                            }
                        }
                    }
                });
            }
        }
        if (typeof grecaptcha !== 'undefined') {
            grecaptcha.execute($("#connexionForm #sitekeyGForm").val(), { action: 'login' }).then(function (token) {
                loginFormSubmitted(token);
            });
        }
        else {
            loginFormSubmitted("");
        }
        return false;
    });
    $("#changePasswordForm").submit(function () {
        var $newPassword = $("#password");
        var $passwordConfirm = $("#passwordconfirm");
        var testValidNewPassword = passwordConfirmWithConstraint($newPassword.val(), $passwordConfirm.val());
        if (!testValidNewPassword) {
            $newPassword.val('');
            $passwordConfirm.val('');
        }
        return testValidNewPassword;
    });
    $("#passwordForgottenSendMail").on("click", function () {
        var email = $("#email").val();
        // validation email
        var emailregexp = /^[^@]+@[^@]+\.[^@]{2,}$/;
        var testValidEmail = emailregexp.test(email);
        if (testValidEmail) {
            Seed.Ajax.Post({
                url: root + "../../EPortail/source/ajax/forgottenPasswordSendMail.php",
                data: "moduleType=" + moduleType
                    + "&email=" + email
                    + "&language=" + $("#connectionButton").attr('data-language'),
                async: true,
                success: function (resultJson) {
                    var resultObj = JSON.parse(resultJson);
                    var $passwordForgottenAlert = $("#passwordForgottenAlert");
                    $passwordForgottenAlert.html(resultObj['msg']);
                    if (resultObj['success']) {
                        $passwordForgottenAlert.removeClass("alert-danger alert-success").addClass('alert-success');
                        // masquage des boutons et disparition automatique de la fenetre 'modal'
                        $("#email").prop("disabled", true);
                        $('#passwordForgottenButtonWrapper').hide();
                        setTimeout(function () { $('#passwordForgottenModal').modal('hide'); }, 5000);
                    }
                    $passwordForgottenAlert.show();
                }
            });
        }
        else {
            $("#passwordForgottenAlert").html(MSG_INVALID_EMAIL).show();
        }
    });
    $("#passwordForgottenLink").on("click", function () {
        $("#passwordForgottenAlert").removeClass("alert-danger alert-success")
            .addClass('alert-danger')
            .hide();
        $("#email").prop("disabled", false).val('');
        $('#passwordForgottenButtonWrapper').show();
        $('#passwordForgottenModal').modal('show');
    });
    $("#cgu_link").on("click", function (event) {
        event.preventDefault();
        getAndDisplayCgu(false);
    });
}
//# sourceMappingURL=loginController.js.map